export const articleContent: Record<string, {
  id: string;
  title: string;
  category: string;
  date: string;
  readTime: string;
  author: string;
  image: string;
  content: Array<{ type: "paragraph" | "heading" | "image"; text?: string; src?: string; alt?: string }>;
}> = {
  "art-1": {
    id: "art-1",
    title: "东方香氛的前世今生：从宫廷御香到现代调香艺术",
    category: "香氛文化",
    date: "2025-12-15",
    readTime: "8 分钟",
    author: "媚肉之香编辑部",
    image: "https://readdy.ai/api/search-image?query=Elegant%20traditional%20Chinese%20incense%20ceremony%20with%20bronze%20censer%20and%20rising%20smoke%2C%20warm%20ambient%20light%2C%20ancient%20aesthetic%20with%20silk%20and%20wood%20elements%2C%20editorial%20photography%20style%2C%20serene%20atmosphere%2C%20cultural%20heritage%20vibe&width=1600&height=800&seq=article-hero-incense-01&orientation=landscape",
    content: [
      { type: "paragraph", text: "东方香氛的历史，可以追溯到数千年前的远古时代。从最初的焚烧香木以祭祀天地，到后来成为宫廷贵族生活中不可或缺的雅事，再到如今融入现代生活的调香艺术，东方香氛走过了一段辉煌而又曲折的演进之路。" },
      { type: "heading", text: "汉代：博山炉中的一缕青烟" },
      { type: "paragraph", text: "汉代是中国香文化的第一个高峰。博山炉的出现，标志着焚香从宗教祭祀走向了生活美学。博山炉造型精美，炉盖层层叠叠如山峦，香料在炉中燃烧时，烟气从山峦间的孔洞中袅袅升起，仿若仙境。汉武帝时期的宫廷中，香料的使用已经非常普遍，龙脑香、苏合香等珍贵香料从西域传入中原。" },
      { type: "heading", text: "唐宋：香道文化的高峰" },
      { type: "paragraph", text: "唐宋时期，香文化达到了一个前所未有的高峰。唐代的香文化深受佛教影响，香在佛事活动中扮演着重要角色。而到了宋代，香已经完全融入文人雅士的日常生活。宋代文人黄庭坚甚至提出了香有十德之说，将品香提升到了精神修养的高度。" },
      { type: "paragraph", text: "宋人对于香料的调配已经达到了极为精妙的程度。合香技法的发展，使得调香成为一门独立的艺术。沉香的深邃、檀香的温和、丁香的辛烈、龙脑的清凉......不同香料按照特定比例调配，创造出层次丰富的香品。" },
      { type: "heading", text: "明清：宫廷御香的鼎盛" },
      { type: "paragraph", text: "明清两代，宫廷用香达到了鼎盛。明代永乐年间编纂的《香乘》是迄今为止最为全面的香学典籍，收录了数百种香方和用香方法。清代宫廷对香料的使用更为讲究，不仅用于熏衣、熏被，还衍生出了香囊、香珠等佩戴方式。" },
      { type: "heading", text: "现代：东方香调的文艺复兴" },
      { type: "paragraph", text: "进入现代，西方香水工业的兴起一度让东方传统香文化显得有些沉寂。但近年来，随着东方美学的复兴和中国消费者对文化自信的增强，东方香调正在经历一场华丽的回归。" },
      { type: "paragraph", text: "媚肉之香正是这场东方香调文艺复兴中的一员。我们将千年香道智慧与现代调香技术相结合，甄选全球优质天然原料，创造出既有东方韵味又符合当代审美的香氛作品。从暗夜玫瑰的浓郁深邃，到檀韵清音的沉静悠远，再到桂月凝香的诗意温婉——每一款香氛都是对东方香文化的一次深情致敬。" },
      { type: "paragraph", text: "香，从来不只是气味的堆叠。它是一种记忆，一种情绪，一种无法言说的魅力。当我们涂抹一款东方香调的香氛，我们接续的是千年文明中那一缕从未熄灭的馨香。" },
    ],
  },
  "art-2": {
    id: "art-2",
    title: "香氛与情绪：如何用香气调节你的身心状态",
    category: "芳香生活",
    date: "2025-11-28",
    readTime: "6 分钟",
    author: "媚肉之香编辑部",
    image: "https://readdy.ai/api/search-image?query=Elegant%20aromatherapy%20scene%20with%20essential%20oils%20and%20dried%20flowers%20on%20wooden%20table%2C%20warm%20natural%20light%20from%20window%2C%20spa%20wellness%20aesthetic%2C%20calm%20and%20peaceful%20composition%2C%20editorial%20photography&width=1600&height=800&seq=article-hero-aromatherapy-02&orientation=landscape",
    content: [
      { type: "paragraph", text: "你有没有过这样的经历？闻到某种特定的香气，突然之间，一段尘封已久的记忆浮上心头，或者一股莫名的情绪涌上心间。这不是偶然——香气与情绪之间，有着深刻的科学与心理联系。" },
      { type: "heading", text: "嗅觉：最古老的情绪开关" },
      { type: "paragraph", text: "在人类的五种感官中，嗅觉是唯一直接连接大脑边缘系统（情绪中枢）的感官。当我们吸入香气分子，它们通过鼻腔中的嗅觉感受器，直接将信号传递到杏仁核和海马体——这两个脑区分别负责情绪处理和记忆存储。这就是为什么香气能够如此迅速地唤起情绪反应和记忆。" },
      { type: "heading", text: "不同香调的情绪效应" },
      { type: "paragraph", text: "木质调（如檀香、雪松）：木质调的香气通常给人以沉稳、安定的感觉。研究表明，檀香具有镇静和集中注意力的效果，非常适合在工作或冥想时使用。媚肉之香的檀韵清音正是以此为核心，帮助使用者在繁忙的日常中找到内心的平静。" },
      { type: "paragraph", text: "花香调（如玫瑰、桂花）：花香调往往与愉悦、浪漫的情绪相关联。玫瑰精油的香气可以促进大脑释放多巴胺，带来幸福感和满足感。暗夜玫瑰和桂月凝香都是极佳的情绪提升香氛。" },
      { type: "paragraph", text: "柑橘调（如佛手柑、柑橘）：清新明快的柑橘调能够提振精神、消除疲劳。虽然媚肉之香主要以东方香调为主，但在我们的肌肤养护系列中，也巧妙地融入了柑橘调的元素，带来清爽的使用体验。" },
      { type: "heading", text: "建立你的香氛仪式" },
      { type: "paragraph", text: "想要充分利用香氛的情绪调节作用，关键是建立属于自己的香氛仪式。早晨出门前，选择一款提振精神的香氛；工作间隙，涂抹带有木质调香气的护手霜让心情平静；睡前使用玫瑰精华油进行面部按摩，让身心在温柔的花香中放松下来。" },
      { type: "paragraph", text: "香气，是最温柔的自我关怀。它不仅能够改变你的情绪状态，更能够在日复一日的使用中，成为你独特的气息标识——那是一种无法被模仿的魅力。" },
    ],
  },
  "art-3": {
    id: "art-3",
    title: "秋冬香氛指南：温暖木质调与东方辛香调的搭配艺术",
    category: "穿搭指南",
    date: "2025-11-10",
    readTime: "5 分钟",
    author: "媚肉之香编辑部",
    image: "https://readdy.ai/api/search-image?query=Elegant%20autumn%20winter%20fragrance%20collection%20on%20wool%20scarf%20with%20warm%20candlelight%2C%20cozy%20luxury%20aesthetic%2C%20dark%20wood%20and%20amber%20tones%2C%20editorial%20product%20photography%2C%20intimate%20atmosphere&width=1600&height=800&seq=article-hero-winter-03&orientation=landscape",
    content: [
      { type: "paragraph", text: "随着气温逐渐降低，空气中的风带来了冬天的讯息。这个季节，我们需要的不只是一件温暖的外套，更需要一款与之匹配的香氛，让温暖从内而外散发。" },
      { type: "heading", text: "秋冬选香的核心法则" },
      { type: "paragraph", text: "相较于春夏的清新明快，秋冬香氛更适合选择浓郁、温暖的调性。木质调和东方辛香调是这个季节的绝佳选择——它们的分子结构较大，挥发速度较慢，在低温环境中能够保持更持久的留香时间，同时也与秋冬厚重的衣着风格相得益彰。" },
      { type: "heading", text: "场景化香氛搭配推荐" },
      { type: "paragraph", text: "职场通勤：推荐檀韵清音。沉稳的檀木香调给人专业、可靠的印象，温和不张扬的扩散度也非常适合办公环境。搭配一件驼色或深灰的大衣，整个人散发出的是内敛而有力的气场。" },
      { type: "paragraph", text: "周末约会：推荐暗夜玫瑰。深邃的玫瑰花香与乌木的交织，在秋冬的冷空气中更显神秘而迷人。搭配黑色高领毛衣与红色唇膏，营造出令人难以抗拒的女性魅力。" },
      { type: "paragraph", text: "温暖宅家：推荐使用玫瑰精华油进行面部护理，再涂上檀香护手霜。木质香与花香的融合，为居家时光增添一份精致而惬意的仪式感。" },
      { type: "heading", text: "叠香的艺术" },
      { type: "paragraph", text: "如果你想要创造出真正独一无二的香气，不妨尝试叠香。先用一款木质调的身体乳（如沉香润体乳）打好底香，再喷上花香调的香氛。两层香气在肌肤上相互交融，形成只属于你的独特味道。" },
      { type: "paragraph", text: "这个秋冬，让媚肉之香陪你度过每一个温暖而迷人的日子。" },
    ],
  },
  "art-4": {
    id: "art-4",
    title: "香氛的层次之美：前调、中调与后调的奥秘",
    category: "香氛文化",
    date: "2025-10-20",
    readTime: "7 分钟",
    author: "媚肉之香编辑部",
    image: "https://readdy.ai/api/search-image?query=Elegant%20fragrance%20notes%20pyramid%20illustration%20with%20perfume%20bottles%20and%20natural%20ingredients%20on%20cream%20background%2C%20editorial%20style%2C%20warm%20soft%20lighting%2C%20educational%20aesthetic%2C%20sophisticated%20composition&width=1600&height=800&seq=article-hero-notes-04&orientation=landscape",
    content: [
      { type: "paragraph", text: "一款优秀的香氛如同一首精妙的交响乐，有着层次分明的结构。理解香氛的前调、中调和后调，是真正欣赏香氛之美的关键。" },
      { type: "heading", text: "前调：初见的第一印象" },
      { type: "paragraph", text: "前调是你在喷上香氛后最先闻到的味道，通常持续5-15分钟。前调的分子最轻、挥发最快，往往是柑橘调、清新绿调或轻盈花香调。它们负责在最初的瞬间抓住你的注意力，留下第一印象。" },
      { type: "heading", text: "中调：香氛的灵魂" },
      { type: "paragraph", text: "中调在前调消散后浮现，是一款香氛最核心的个性表达，通常持续2-4小时。花香调、辛香调、草本调常常担任中调的角色。以暗夜玫瑰为例，它的中调是浓郁的大马士革玫瑰，这正是这款香氛最打动人心的灵魂所在。" },
      { type: "heading", text: "后调：持久的余韵" },
      { type: "paragraph", text: "后调是香氛的基底，分子最重、挥发最慢，能够持续数小时甚至一整天。木质调、琥珀调、麝香调是常见的后调选择。檀韵清音的后调以印度老山檀香和琥珀为主，为整款香氛奠定了沉静悠远的基调。也是你离开房间后，留在空气中最后一丝痕迹的来源。" },
      { type: "paragraph", text: "了解了这些，下次试香时不妨多等待片刻，让香氛的每一个层次都在你的肌肤上充分展现，你才能真正找到与自己的体香完美契合的那一款。" },
    ],
  },
  "art-5": {
    id: "art-5",
    title: "以香养肤：当东方香道遇见现代护肤科学",
    category: "芳香生活",
    date: "2025-09-15",
    readTime: "5 分钟",
    author: "媚肉之香编辑部",
    image: "https://readdy.ai/api/search-image?query=Elegant%20natural%20skincare%20ingredients%20with%20essential%20oils%20and%20herbs%20on%20wooden%20surface%2C%20spa%20wellness%20aesthetic%2C%20warm%20natural%20lighting%2C%20editorial%20photography%2C%20clean%20organic%20composition&width=1600&height=800&seq=article-hero-skincare-05&orientation=landscape",
    content: [
      { type: "paragraph", text: "香，不只是用来闻的。在东方传统文化的智慧中，香与肤之间存在着深层的联结——良好的香气可以调节身心，而健康的肌肤则是香气最好的载体。" },
      { type: "heading", text: "沉香：千年养肤的东方之宝" },
      { type: "paragraph", text: "沉香作为东方香料之首，不仅在香道中占据重要地位，在护肤领域同样有着不可替代的价值。沉香精油含有丰富的倍半萜类化合物，具有良好的抗炎、抗氧化功效。媚肉之香的沉香润体乳，将沉香精油的护肤价值与乳木果油的深层滋润力完美结合，让每一次涂抹都成为一场芳香疗愈。" },
      { type: "heading", text: "玫瑰：美肌与香氛的双重馈赠" },
      { type: "paragraph", text: "大马士革玫瑰不仅是香氛界的女王，也是护肤界的宝藏。玫瑰精油和玫瑰纯露富含多种维生素和抗氧化物质，能够帮助肌肤保湿、提亮、舒缓和抗衰。玫瑰精华油高度浓缩了玫瑰精油的护肤力量，配合角鲨烷的屏障修护力，让肌肤在玫瑰芬芳中日渐莹润饱满。" },
      { type: "heading", text: "以香养肤的日常仪式" },
      { type: "paragraph", text: "每天沐浴后，在微湿的肌肤上涂抹沉香润体乳，趁着毛孔尚未完全闭合，让沉香的滋养成分与芬芳深入肌肤。睡前，取2-3滴玫瑰精华油，在掌心温热后轻轻按压于面部，深呼吸三次，让玫瑰的芬芳伴你进入甜美梦乡。" },
      { type: "paragraph", text: "以香养肤，既是对肌肤的呵护，也是对心灵的滋养。这正是媚肉之香希望在每一款产品中传达的理念——让美丽从香气中诞生，让香气在美丽中永存。" },
    ],
  },
  "art-6": {
    id: "art-6",
    title: "香氛送礼指南：不同场合如何挑选最合适的香氛礼物",
    category: "穿搭指南",
    date: "2025-08-22",
    readTime: "4 分钟",
    author: "媚肉之香编辑部",
    image: "https://readdy.ai/api/search-image?query=Elegant%20luxury%20gift%20boxes%20with%20ribbons%20and%20fragrance%20bottles%20on%20silk%20fabric%2C%20warm%20golden%20lighting%2C%20festive%20yet%20minimalist%20aesthetic%2C%20editorial%20product%20photography%2C%20sophisticated%20presentation&width=1600&height=800&seq=article-hero-gift-06&orientation=landscape",
    content: [
      { type: "paragraph", text: "香氛是世界上最受欢迎的礼物之一——它精致、私密又充满情感。但正因为香氛与个人的气质和品味紧密相连，选对香氛作为礼物需要一点技巧。" },
      { type: "heading", text: "送香氛的基本原则" },
      { type: "paragraph", text: "如果是送给亲近的朋友或伴侣，可以选择符合对方性格气质的香调——沉静内敛的朋友适合木质调，浪漫热烈的朋友适合花香调。如果是送给不太熟悉的人，建议选择中性温和的香调，或者直接选择体验礼盒，让对方在多种香调中找到心仪之选。" },
      { type: "heading", text: "按场合推荐" },
      { type: "paragraph", text: "情人节/纪念日：倾城·玫瑰香礼套装是最佳之选。暗夜玫瑰的深邃加上玫瑰精华油的温柔，玫瑰的双重浪漫，让爱意在香气中流淌。" },
      { type: "paragraph", text: "闺蜜生日：初见·香氛体验礼盒既贴心又不失格调。四款香调一次体验，让她感受到被认真对待的喜悦。兰芷清芬的清新优雅也是送给女性朋友的不出错之选。" },
      { type: "paragraph", text: "节日/商务送礼：禅意·身心养护礼盒体面大方。檀木香的沉稳气质适合各种送礼场景，养护与香氛的结合也展现了对收礼人身心健康的关怀。" },
      { type: "paragraph", text: "香氛送礼的真正艺术，不在于价格的高低，而在于你对收礼人的了解与用心。选择一款她/他可能喜欢的香气，附上一张手写的祝福卡片——这份用心的温度，才是最好的礼物。" },
    ],
  },
  "delivery": {
    id: "delivery",
    title: "配送说明",
    category: "客户服务",
    date: "2025-06-01",
    readTime: "2 分钟",
    author: "媚肉之香客服团队",
    image: "https://readdy.ai/api/search-image?query=Elegant%20luxury%20package%20delivery%20concept%20with%20gift%20box%20and%20ribbon%20on%20cream%20background%2C%20warm%20natural%20light%2C%20minimalist%20aesthetic%2C%20premium%20ecommerce%20photography%2C%20clean%20composition&width=1600&height=800&seq=article-hero-delivery&orientation=landscape",
    content: [
      { type: "paragraph", text: "媚肉之香致力于为您提供优质的配送服务体验。以下是我们的配送政策详细信息。" },
      { type: "heading", text: "配送范围" },
      { type: "paragraph", text: "我们目前覆盖全国30多个主要城市，包括北京、上海、广州、深圳、杭州、成都、重庆、武汉、南京等。更多城市正在逐步开通中。" },
      { type: "heading", text: "配送时效" },
      { type: "paragraph", text: "一线城市：下单后1-2个工作日送达。二线城市：下单后2-3个工作日送达。偏远地区：下单后3-5个工作日送达。所有订单在每日16:00前完成支付，将于当日发出。" },
      { type: "heading", text: "配送费用" },
      { type: "paragraph", text: "单笔订单满¥299享免费配送。不满¥299的订单，根据配送地址收取¥15-25不等的配送费用。" },
      { type: "heading", text: "包装说明" },
      { type: "paragraph", text: "所有媚肉之香产品均采用精美礼盒包装，外加固运输保护层，确保产品完好送达您的手中。如收到产品时发现外包装有明显破损，请在签收前拍照留存并联系客服。" },
    ],
  },
};